import { Label } from 'components/atoms/Texts/TxtLabel'
import React from 'react'

export const tableIdFormatter = (cell, row, rowIndex, formatExtraData) => {
  const { options, field } = formatExtraData

  const tableId = options.find(d => d.value === row[field]) || {}
  return (
    <Label color={tableId.color}>{tableId.label}</Label>
  )
}
